<template>
  <span @click="toggleState">
    <label v-if="label" class="text-xxs font-medium text-white mx-2 leading-5">
      {{ label }}
    </label>
    <Switch
      class="
        absolute
        inline-flex
        flex-shrink-0
        h-6
        w-11
        border-2
        align-top
        border-transparent
        rounded-full
        cursor-pointer
        transition-colors
        ease-in-out
        duration-200
        focus:outline-none
        focus:ring-2 focus:ring-offset-2 focus:ring-vice-teal-500
      "
      :class="[isEnabled ? 'bg-vice-teal-500' : 'bg-gray-200']"
    >
      <span
        class="
          pointer-events-none
          relative
          inline-block
          h-5
          w-5
          rounded-full
          bg-white
          shadow
          transform
          ring-0
          transition
          ease-in-out
          duration-200
        "
        :class="[isEnabled ? 'translate-x-5' : 'translate-x-0']"
      >
        <span
          :class="[
            isLoading ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100',
            'absolute inset-0 h-full w-full flex items-center justify-center animate-spin z-10',
          ]"
          aria-hidden="true"
        >
          <svg class="bg-white h-3 w-3 text-vice-teal-500" fill="none" viewBox="0 0 14 14">
            <circle cx="7" cy="7" r="6" stroke-dasharray="30" stroke="#24b8a7" stroke-width="2" />
          </svg>
        </span>

        <span
          :class="[
            isEnabled ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200',
            'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
          ]"
          aria-hidden="true"
        >
          <svg class="h-3 w-3 text-vice-teal-500" fill="none" viewBox="0 0 12 12">
            <path
              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <span
          :class="[
            isEnabled ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100',
            'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
          ]"
          aria-hidden="true"
        >
          <svg class="h-3 w-3 text-vice-teal-500" fill="currentColor" viewBox="0 0 12 12">
            <!-- eslint-disable-next-line max-len -->
            <path
              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414
             0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414
              1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
            />
          </svg>
        </span>
      </span>
    </Switch>
  </span>
</template>

<script>
import { Switch } from '@headlessui/vue';
import { onMounted } from 'vue';

export default {
  name: 'ToggleStethoscopePlayback',
  emits: ['state-toggled'],
  props: {
    isEnabled: Boolean,
    isLoading: Boolean,
    label: String,
  },
  components: {
    Switch,
  },
  setup(props, { emit }) {
    const toggleState = () => {
      if (props.isLoading) return;
      emit('state-toggled');
    };

    onMounted(() => toggleState());

    return {
      toggleState,
    };
  },
};
</script>

<style scoped></style>
